import React from 'react';
import { AnimatedShinyText } from './ui/animated-shiny-text';

const BetaRecruitment = () => {
  return (
    <div className="mt-6 flex items-center justify-center">
      <div className="relative inline-flex items-center justify-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 hover:border-white/30 transition-all duration-300 hover:bg-white/15">
        {/* Content */}
        <div className="relative z-10">
          <AnimatedShinyText
            className="inline-flex items-center justify-center transition ease-out hover:text-neutral-600 hover:duration-300 hover:dark:text-neutral-300"
            shimmerWidth={150}
          >
            <span className="mr-2 text-lg">🚀</span>
            <span className="text-sm font-medium text-white/90">Recruiting beta testers now</span>
          </AnimatedShinyText>
        </div>
      </div>
    </div>
  );
};

export default BetaRecruitment;